export default "__VITE_ASSET__cc4c9f55__"